export { default } from './SpecificationBadge';
